// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2Y2s0","header":"MessagesList_header__3wyFa","chat":"MessagesList_chat__Tu8qa"};